namespace('arctic.views.common.failedCards');

compass.require('compass.demographic.FailedCreditCardWidget');

arctic.views.common.failedCards = function(viewport,options) {

    // starts measuring the time it takes for the view to load
    compass.startLoad('failedCards');

    /*
     * properties.
     */
    var _viewport = viewport;
    var _d = jQuery.dom;
    var d = _d;
    var $j = jQuery;
    var _settings = options;
    var _pageJSON = {};
	var _hasCutOffReservations;
	var _hasComplexPayments;
	var _failedCardCount;
	var _fixableCardCount;

    var me = this;

    var _labels = {
        header: 'Credit Cards Missing',
        unableToProcessGroup: 'We were unable to process some credit cards for your group. ',
        updatePaymentInfo: 'Update the payment information or re-try the current card below to avoid cancellation.',
        counts: '<div class="atRiskWrapper"><span class="bold"><%= atRisk %></span>&nbsp;of&nbsp;<span class="bold"><%= totalReservations %></span>&nbsp;reservations at&nbsp;risk&nbsp;of&nbsp;cancellation&nbsp;</div><span class="requireUpdatesWrapper"><span class="bold"><%= failedCards %></span>&nbsp;credit&nbsp;cards require&nbsp;updates </span>',
        footer: 'You may access the rest of your reservation without updating the credit cards above, but the rooms may be subject to cancellation at any time.',
        cutOffMessage : 'You have outstanding balances for hotels that are cutoff. Please contact the hotel directly to resolve.',
        complexMessage : 'You have outstanding balances for reservations with complex payments. Please call onPeak at 855-992-3353.'
    };

    var _eventTypes = {
        individual : "FailedCardIndividual",
        group : "FailedCardGroup",
        groupMember : "FailedCardMember"
    };

    var _proceedButton;

    var _updatedPayments = [];

    var _render = function(data) {
        var failedCardsViewContainer = d.div({className: 'failedCards'});
        failedCardsViewContainer.append(_drawHeader());
		failedCardsViewContainer.append(_drawCutoffAndComplexBars());														
        failedCardsViewContainer.append(_drawCountsBar());
        failedCardsViewContainer.append(_drawFailedCards());
        failedCardsViewContainer.append(_drawFooter());

        _viewport.append(failedCardsViewContainer);

        _viewport.bind('FailedCreditCardWidget.updateFailedCard', _updateFailedCard);
        _viewport.bind('StayRecapWidget.showPolicies', _showPoliciesPopup);
    };

    var _updateFailedCard = function(event, eventData) {
        $j.ajax({
            data: JSON.stringify({
                originalPaymentId: eventData.originalPaymentId,
                newPaymentInfo: eventData.newPaymentInfo
            }),
            type: 'POST',
            url: '/updateFailedCard',
            contentType : 'application/json',
            success: function(data) {
                eventData.callback(data);
                if (_.contains(_updatedPayments, eventData.originalPaymentId) === false) {
                    _updatedPayments.push(eventData.originalPaymentId);
                }
                if ((_.size(_updatedPayments) >= _.size(_pageJSON.reservationsGroupedByPayment)) && _proceedButton.hasClass('disabled')) {
                    _proceedButton.removeClass('disabled');
                    _proceedButton.activate(_handleProceedButtonClick);
                }
			_viewport.append(d.div({className:'_failedCardProcessed_', style : 'display:none'}));

            },
            error: function() {
                eventData.errorCallback();
            }
        });
    };

    var _showPoliciesPopup = function(data, stayRecapData) {
      jQuery.ajax({
        data: {
          blocked_room_id: stayRecapData.blockedRoomId
        },
        dataType:'json',
        traditional: true,
        url:'/policies',
        success : function(data) {
          var policiesDiv = d.div({className:'policiesContainer'});

          _policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv,
            {
              WUID : 'policiesWidget_individualPersonalInfo',
              policies: data
            });

          _policiesDialog = d.dialog({
            classes: 'personalInfo policiesDialog',
            contents: policiesDiv,
            centerOnView: true
          });
        }
      });
    };

    var _drawHeader = function() {
        var headerContainer = d.div({className: 'headerContainer'});
        headerContainer.append(d.div({className: 'headerTitle bold'}, _labels.header));
        
        var messageText = '';
        if (_isGroup()) {
            headerContainer.append(d.div({className: 'groupName bold'}, _groupName()));
            messageText += _labels.unableToProcessGroup;
        }
        messageText += _fixableCardCount > 0 ? _labels.updatePaymentInfo : '';
        headerContainer.append(d.div(messageText));
        
        return headerContainer;
    };

    var _drawCountsBar = function() {
        if (!_isGroup()) { return undefined; }

        var atRiskReservationCount = _pageJSON.totalFailedReservations;
        var totalReservationCount = _pageJSON.totalReservations;

				var countsTemplate = _.template(_labels.counts);
        return d.div({className: 'countsContainer'},
            d.span({className: 'countsText'}, countsTemplate({
                atRisk: atRiskReservationCount,
                totalReservations: totalReservationCount,
                failedCards: _failedCardCount
            }))
        );
    };

    var _drawCutoffAndComplexBars = function() {

        return [(_hasCutOffReservations ? d.div({className: 'messageContainer cutoff'},
            		d.span({className: 'messageText'}, _labels.cutOffMessage  )
        			) : null),
        		(_hasComplexPayments ?  d.div({className: 'messageContainer complex'},
            		d.span({className: 'messageText'}, _labels.complexMessage )
        			) : null ),
        	];
    };


    var _drawFailedCards = function() {
        var failedCardsContainer = d.div({className: 'failedCardsContainer'});
        var _failedCards = _.each(_pageJSON.reservationsGroupedByPayment, function(reservations, payment_id) {
            return new compass.demographic.FailedCreditCardWidget(failedCardsContainer, {
                paymentId: payment_id,
                reservations: reservations,
                meetingInfo: _settings.meetingInfo,
                storedPayments: _pageJSON.payments,
                paymentOptions: _pageJSON.paymentOptions,
                countriesAndStates: _pageJSON.countriesAndStates
            });
        });

        return failedCardsContainer;
    };

    var _drawFooter = function() {
        var footerContainer = d.div({className: 'footerContainer'});
        if (_isGroup() && _fixableCardCount > 0) {
            footerContainer.append(d.div({className: 'footerText'}, _labels.footer));
        }

        _proceedButton = d.button({className: 'proceedButton button'}, 'Proceed');
        if (_isGroup() || _fixableCardCount === 0  ) {
            _proceedButton.activate(_handleProceedButtonClick);
        } else {
            _proceedButton.addClass('disabled');
        }
        footerContainer.append(_proceedButton);
        
        return footerContainer;
    };

    var _handleProceedButtonClick = function(event) {
        if (_isGroup()) {
            _viewport.trigger(CompassEvents.Navigate, 'groupManage');
        } else {
            /* for individuals we send a confirmation because they don't go through the groupManage page which sends confirmations for a group*/
            if ( _fixableCardCount > 0 ){
	            jQuery.ajax({
	                url : '/sendConfirmation'
	            });
			}            
            _viewport.trigger(CompassEvents.Navigate, 'frontDesk');
        }
    };

    // The following functions are to help abstract away from the mock data easier later on
    var _isGroup = function() {
        return _pageJSON.pageSpecificData.userType === 'group';
    };
    var _groupName = function() {
        return _pageJSON.pageSpecificData.groupName;
    };
    // End mock wrappers

    var _setupControls = function() {
    };

    this.run = function(renderComplete) {
        compass.loading.start();
        jQuery.ajax({
            url : '/failedCards',
            success : function(data) {
                compass.loading.stop();
                compass.stopLoad('failedCards');

                _pageJSON = data;
                _hasCutOffReservations = _pageJSON.hasCutOffReservations;
                _hasComplexPayments = _pageJSON.hasComplexPayments;
        		_fixableCardCount = _.size(_pageJSON.reservationsGroupedByPayment);
        		_failedCardCount = _pageJSON.totalFailedCards;


                _eventType = _eventTypes[_pageJSON.pageSpecificData.userType];
                compass.trackPageView(_eventType, {
                    src : 'arctic.views.common.failedCards'
                });

                _render();
                _setupControls();
                renderComplete();
            }
        });
    };
};
